export enum FormEngineModeTypeEnum {
  Create = 'create',
  Submit = 'submit',
  Edit = 'edit',
  View = 'view',
  CustomView = 'customview',
}
